/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OAuthFlow } from './OAuthFlow';

/**
 * Models a client credentials OAuth flow.
 * 
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OAuthFlow
 */
export abstract class ClientCredentialsOAuthFlow extends OAuthFlow {
    constructor() {
        super();
    }
}
ClientCredentialsOAuthFlow["__class"] = "io.apicurio.datamodels.core.models.common.ClientCredentialsOAuthFlow";
ClientCredentialsOAuthFlow["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




